import { Search, ChevronUp, ChevronDown, X } from 'lucide-react';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { SpreadsheetSearchBarProps } from '../types';

export function SpreadsheetSearchBar({
  searchTerm,
  onSearchChange,
  currentIndex,
  totalResults,
  onNextSearch,
  onPreviousSearch,
  onClearSearch,
  onClose,
  spreadsheetId
}: SpreadsheetSearchBarProps) {
  return (
    <div 
      className="search-bar absolute top-2 right-6 z-[100] bg-white border border-gray-300 rounded-lg shadow-lg" 
      data-spreadsheet-id={spreadsheetId}
    >
      <div className="flex items-center gap-1 px-1 py-1">
        <div className="relative">
          <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-3 w-3 text-gray-400" />
          <Input
            type="text"
            placeholder="Find in sheet"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-6 pr-2 h-7 w-40 text-xs rounded-lg border dark:border-gray-200 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 dark:bg-white dark:text-gray-900 dark:placeholder-gray-500"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                if (e.shiftKey) {
                  onPreviousSearch();
                } else {
                  onNextSearch();
                }
              } else if (e.key === 'Escape') {
                e.preventDefault();
                onClearSearch();
                onClose();
              }
            }}
            autoFocus
          />
        </div>
        {searchTerm && (
          <>
            <div className="text-xs text-gray-500 min-w-[50px] text-center">
              {totalResults > 0 ? `${currentIndex + 1}/${totalResults}` : '0/0'}
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onPreviousSearch}
              disabled={totalResults === 0}
              className="h-5 w-5 p-0 hover:bg-gray-100 text-gray-600 hover:text-gray-800"
            >
              <ChevronUp className="h-3 w-3" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onNextSearch}
              disabled={totalResults === 0}
              className="h-5 w-5 p-0 hover:bg-gray-100 text-gray-600 hover:text-gray-800"
            >
              <ChevronDown className="h-3 w-3" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onClearSearch();
                onClose();
              }}
              className="h-5 w-5 p-0 hover:bg-gray-100 text-gray-600 hover:text-gray-800"
            >
              <X className="h-3 w-3" />
            </Button>
          </>
        )}
      </div>
    </div>
  );
} 